"use strict";
const mobileMenuContent = [
  {
    title: "Deli Swap",
    items: [
      { label: "Home", href: "/" },
      { label: "Documentation", href: "https://bmxdefi.notion.site/bmx-docs" }
    ]
  },
  {
    title: "BMX Ecosystem",
    items: [
      { label: "Stake BMX", href: "https://classic.bmx.trade/deli-shop/single-staking" },
      { label: "Governance", href: "https://snapshot.box/#/s:bmxonbase.eth" }
    ]
  }
];
const desktopMenuContent = [
  {
    title: "",
    items: [
      { label: "Home", href: "/" },
      { label: "Documentation", href: "https://bmxdefi.notion.site/bmx-docs" },
      { label: "Stake BMX", href: "https://classic.bmx.trade/deli-shop/single-staking" },
      { label: "Governance", href: "https://snapshot.box/#/s:bmxonbase.eth" }
    ]
  }
];
export const useMenuContent = () => desktopMenuContent;
export const useMobileMenuContent = () => mobileMenuContent;
export const flatDesktopMenuItems = desktopMenuContent[0]?.items ?? [];
